import groupModule from '../groupModule';

function shoutInputElement($timeout) {
    "ngInject";
    return {
        link: function (scope, element, attrs) {  
            scope.$watch(function () {
                return scope.layout.shoutInputFocused;
            }, function (newVal, oldVal) {
                if (newVal === true) {
                    $timeout(function () {
                        element[0].focus();
                    });
                }
            });

            // on focus: 
            element.on('focus', function () {
                var self = this;
                if (scope.layout.focusedElement != self) {
                    scope.layout.focusedElement = self;
                    $timeout(function () {
                        self.select();
                    }, 10);
                }
            });

            // on blur:
            element.on('blur', function () {
                scope.layout.focusedElement = null;
                scope.layout.shoutInputFocused = false;
            });
        }
    }
};

groupModule.directive("shoutInputElement", shoutInputElement);

export default shoutInputElement;